export default "__VITE_PUBLIC_ASSET__ec2cd42b__"